import { FileUploadComponent } from './file-upload/file-upload.component';
import { HistoricalObservationsModalComponent } from './historical-observations-modal/historical-observations-modal.component';
import { TicketBillingComponent } from './ticket-billing/ticket-billing.component';
import { TicketCareComponent } from './ticket-care/ticket-care.component';
import { TicketCountChartComponent } from './ticket-count-chart/ticket-count-chart.component';
import { TicketDetailContactComponent } from './ticket-detail-contact/ticket-detail-contact.component';
import { TicketDetailHeaderComponent } from './ticket-detail-header/ticket-detail-header.component';
import { TicketDetailServiceComponent } from './ticket-detail-service/ticket-detail-service.component';
import { TicketDisconnectComponent } from './ticket-disconnect/ticket-disconnect.component';
import { TicketIqObservationComponent } from './ticket-iq-observation/ticket-iq-observation.component';
import { TicketListDisplayComponent } from './ticket-list-display/ticket-list-display.component';
import { TicketNocComponent } from './ticket-noc/ticket-noc.component';
import { TicketSuccessComponent } from './ticket-success/ticket-success.component';
import { TicketTOBComponent } from './ticket-tob/ticket-tob.component';
import { TicketTopComponent } from './ticket-top/ticket-top.component';
import { TicketTypeChartComponent } from './ticket-type-chart/ticket-type-chart.component';

export const components = [
  TicketDetailContactComponent,
  TicketDetailHeaderComponent,
  TicketDetailServiceComponent,
  TicketListDisplayComponent,
  TicketSuccessComponent,
  TicketTopComponent,
  TicketTypeChartComponent,
  TicketCountChartComponent,
  TicketIqObservationComponent,
  HistoricalObservationsModalComponent,
];

export const standaloneComponents = [
  FileUploadComponent,
  TicketBillingComponent,
  TicketCareComponent,
  TicketTOBComponent,
  TicketNocComponent,
  TicketDisconnectComponent,
];

export * from './historical-observations-modal/historical-observations-modal.component';
export * from './ticket-billing/ticket-billing.component';
export * from './ticket-count-chart/ticket-count-chart.component';
export * from './ticket-detail-contact/ticket-detail-contact.component';
export * from './ticket-detail-header/ticket-detail-header.component';
export * from './ticket-detail-service/ticket-detail-service.component';
export * from './ticket-disconnect/ticket-disconnect.component';
export * from './ticket-iq-observation/ticket-iq-observation.component';
export * from './ticket-list-display/ticket-list-display.component';
export * from './ticket-noc/ticket-noc.component';
export * from './ticket-success/ticket-success.component';
export * from './ticket-tob/ticket-tob.component';
export * from './ticket-top/ticket-top.component';
export * from './ticket-type-chart/ticket-type-chart.component';
